<style scoped>
.loan-summary-title {
  text-align: center;
  font-weight: 600;
}

.loan-summary-table {
  font-size: .9rem;
  margin-top: 10px;
}

>>> .loan-summary-table > thead > tr {
  border-top-style: hidden;
}
</style>

<template>
  <b-row>
    <b-col>
      <div class="loan-summary-title">
        {{ title }}
      </div>
      <div>
        <b-table
          small
          class="loan-summary-table"
          primary-key="loan_id"
          tbody-tr-class="pointer-cursor"
          :items="items"
          :fields="fields"
          :empty-text="emptyText"
          :show-empty="true"
          @row-clicked="clicked"
        >
          <template :slot="dateField" slot-scope="data">
            {{ data.item[dateField]|date }}
          </template>
        </b-table>
        <hr>
      </div>
    </b-col>
  </b-row>
</template>


<script>
export default {
  props: {
    items: Array,
    fields: Array,
    dateField: String,
    title: String,
    emptyText: String,
  },
  methods: {
    clicked(loan) {
      this.$router.push({ name: 'DealDetail', params: { loan_id: loan.loan_id } });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/loan_summary/SummaryTable.vue